import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import styles from "./Overview.module.scss";

const Overview = () => {
  return (
    <section>
      <div className="fw-semibold fs-5 mb-2">Overview</div>
      <Row className="g-0">
        <Col xl="9" xxl="6">
          <Card className={styles.feeDetailsCard}>
            <CardBody>
              <p className={styles.feeCategory}>Transaction Fees:</p>
              <p className={styles.feeDetail}>
                - A 2.9% fee is applied to each sale
              </p>
              <p className={styles.feeDetail}>
                - Additional $0.30 fee per transaction
              </p>

              <p className={styles.feeCategory}>Subscription Fees:</p>
              <p className={styles.feeDetail}>
                - Monthly subscription fee of $29.99 for access to premium
                seller tools
              </p>

              <p className={styles.feeCategory}>Advertising Fees:</p>
              <p className={styles.feeDetail}>
                - Cost-per-click (CPC) advertising with a minimum bid of $0.50
                per click
              </p>

              <p className={styles.feeCategory}>Additional Charges:</p>
              <p className={styles.feeDetail}>
                - Chargeback fee of $15 for each disputed transaction
              </p>
              <p className={styles.feeDetail}>
                - Refund fee of 5% of the sale price for processed refunds
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </section>
  );
};

export default Overview;